import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Telegram_bot } from "../bot_toot/telegram_bot.js";
import {
    collection,
    query,
    where,
    getDocs,
    onSnapshot,
    orderBy,
    limit,
    getCountFromServer
} from "firebase/firestore";
import Loading from "../components_root/loading.jsx";
import { dbstatus } from "../firebase.js";
import { GoDownload, GoHeart } from "react-icons/go";
import Loadingimg from "../components_root/loadingimg.jsx";
import { LuFilter } from "react-icons/lu";
import CopyUID from "../components_root/copyuid.jsx";
import { Toast } from "../components_root/ToastContext.jsx";
import ShareButton from "../components_root/ShareButton.jsx";
import html2canvas from "html2canvas";
import { CiFilter } from "react-icons/ci";
import { Randomnumber } from "../components_root/rendom_number.js";
import Download_popup from "./download_popup.jsx";
import { Update_status_message_qry } from "./update_status_message.js";
import whatsapp from "../assets/icon/whatsapp-icon.png";
import instagram from "../assets/icon/instagram-logo-DjehPe9u.svg";
import youtube from "../assets/icon/youtube-logo-AGOPFgFh.svg";
import { Randomcode } from "../components_root/rendom_code.js";
import { create_comment } from "./create_comment.js";

export default function Status_page({ data }) {

    const navigate = useNavigate();
    const location = useLocation();
    const { Toastshow } = Toast();
    const [downpopup, setdownpopup] = useState(false);
    const [statusdata, setstatusdata] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusmood, setstatusmood] = useState(data?.statusmood);
    const [moodtab, setmoodtab] = useState("home");
    const [statuscomment, setStatuscomment] = useState("");
    const [downloadingId, setDownloadingId] = useState(null);
    const [recentloading, setrecentloading] = useState(true);
    const [commentsloading, setcommentsloading] = useState(true);

    // pagination 
    const [languagemood, setlanguagemood] = useState("Recommended");
    const [recentstatusdata, setrecentstatusdata] = useState([]);
    const [statuslibrary, setstatuslibrary] = useState(0);
    const moodEmoji = {
        happy: "😊",
        shayari: "🪶",
        sad: "😢",
        love: "❤️",
        angry: "😡",
        funny: "😂",
        motivated: "🔥",
        thinking: "🤔",
        business: "💼",
        golden_Rule: "🌟",
        money: "💰"
    };

    const get_recent_status_message = () => {
        let q = null;
        q = query(
            collection(dbstatus, "statusmessage"),
            where("status", "==", true),
            orderBy("date_time", "desc"),
            limit(20)
        );


        const unsubscribe = onSnapshot(q, async (snapshot) => {

            const results = await Promise.all(
                snapshot.docs.map(async (doc) => {

                    const statusData = doc.data();

                    const accQuery = query(
                        collection(dbstatus, "accounts"),
                        where("guid", "==", statusData.guid)
                    );

                    const accSnap = await getDocs(accQuery);

                    let accountInfo = null;

                    accSnap.forEach((acc) => {
                        accountInfo = acc.data();
                    });

                    return {
                        id: doc.id,
                        ...statusData,
                        accountInfo
                    };

                })
            );

            setrecentstatusdata(results);
            setrecentloading(false);
        });

        return unsubscribe;
    };



    // url params
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setmoodtab(params.get("m") || "home");
    }, [location.search]);

    function timeAgo(date) {

        const seconds = Math.floor((Date.now() - new Date(date)) / 1000);

        if (seconds < 60) return seconds + " sec ago";

        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) return minutes + " min ago";

        const hours = Math.floor(minutes / 60);
        if (hours < 24) return hours + " h ago";

        const days = Math.floor(hours / 24);
        if (days < 30) return days + " d ago";

        const months = Math.floor(days / 30);
        if (months < 12) return months + " m ago";

        const years = Math.floor(months / 12);
        return years + " y ago";
    }
    const get_status_library = async () => {
        const q = query(collection(dbstatus, "statusmessage"));

        const snapshot = await getCountFromServer(q);
        setstatuslibrary(snapshot.data().count);

    }
    const [accountsdata, setaccountsdata] = useState([]);

    const get_accounts = async () => {
        const accQuery = query(
            collection(dbstatus, "accounts"),
            where("guid", "==", data.guid)
        );

        const accSnap = await getDocs(accQuery);

        const accountsArray = accSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));

        setaccountsdata(accountsArray);
    };
    useEffect(() => {
        get_accounts();
        get_recent_status_message();
        get_status_library();
    }, [navigate]);
    const poststatuscomment = async () => {
        if (!statuscomment) {
            return;
        }

        try {
            const res = await create_comment({
                message: statuscomment,
                contentid: data.contentid
            });

            if (res?.success) {
                setStatuscomment("");
                //Toastshow("Status message saved");
            } else {
                Toastshow("Error: " + res?.error);
            }

        } catch (err) {
            console.error(err);
            Toastshow("Something went wrong");
        }
    }; const [commentsdata, setCommentsdata] = useState([]);

    const get_comment = () => {

        const q = query(
            collection(dbstatus, "statusmessage", data.contentid, "comments"),
            orderBy("date_time", "desc"),
            limit(50)
        );

        setcommentsloading(true); // ✅ move here

        const unsubscribe = onSnapshot(q, async (snapshot) => {

            const results = await Promise.all(
                snapshot.docs.map(async (docSnap) => {

                    const statusData = docSnap.data();

                    let accountInfo = null;

                    // 🔥 DEBUG
                    if (!statusData.guid) {

                        console.warn("Missing guid in comment:", statusData);
                        return {
                            id: docSnap.id,
                            ...statusData,
                            accountInfo: null
                        };
                    }

                    try {
                        const accQuery = query(
                            collection(dbstatus, "accounts"),
                            where("guid", "==", data.guid)
                        );

                        const accSnap = await getDocs(accQuery);

                        if (accSnap.empty) {
                            console.warn("No account found for guid:", statusData.guid);
                        }

                        accSnap.forEach((acc) => {
                            accountInfo = acc.data();
                        });

                    } catch (err) {
                        console.error("Account fetch error:", err);
                    }

                    return {
                        id: docSnap.id,
                        ...statusData,
                        accountInfo
                    };

                })
            );

            setCommentsdata(results);
            setcommentsloading(false); // ✅ correct place

        });

        return unsubscribe;
    };
    useEffect(() => {
        get_comment();
    }, [navigate, data]);

    return (
        <>


            <div className="container_roots">
                <div className="post-container">
                    <div className="post_updates">

                        <div className="">
                            <table>
                                <tr>
                                    <td>   <div className="text-h1 bold fcap m-top">Status mood</div></td>
                                    <td className="text-r text-off">Library {statuslibrary}</td>
                                </tr>
                            </table>

                        </div>

                        <div className="ui-grid-150 m-top">
                            <div className={`ui-items p-11 rounded-30 cursor ${statusmood === "Recommended" ? "items-back-fill bold  b-1" : "hover"}`} onClick={() => {
                                setstatusmood("Recommended");
                                setlanguagemood("Recommended");

                            }} >
                                <span>✨</span>
                                <span className="fcap">Recommended</span>
                            </div>

                            {Object.entries(moodEmoji).map(([mood, emoji]) => (
                                <div
                                    key={mood}
                                    className={`ui-items cursor rounded-30 p-11 ${statusmood === mood ? "items-back-fill b-1  bold" : "hover"}`}
                                    onClick={() => {
                                        setstatusmood(mood);
                                        setlanguagemood("Recommended");

                                    }}
                                >
                                    <span>{emoji}</span>
                                    <span className="fcap">{mood.replaceAll("_", " ")}</span>
                                </div>
                            ))}
                        </div>


                    </div>
                    <div className="post_div">

                        <div >
                            <table>
                                <tr>
                                    <td>   <div className="text-h1 bold fcap m-2">Status Comments</div></td>
                                    <td className="text-r text-off">Published {data.date_time ? new Date(data.date_time).toLocaleString() : ""}</td>
                                </tr>
                            </table>
                        </div>
                        <div className="ui-items p-2 items-back-fill rounded b-1 ">
                            <table>
                                <tbody>
                                    <tr>
                                        <td width={30}>
                                            <img onClick={() => navigate("/" + accountsdata[0]?.username)}
                                                className="icon-photo-30"
                                                src={accountsdata[0]?.photoURL || "/default-user.png"}
                                                alt="user"
                                            />
                                        </td>

                                        <td onClick={() => navigate("/" + accountsdata[0]?.username)}>
                                            <div className="text-h2 bold">{accountsdata[0]?.name}</div>
                                            <div className="text-h4 text-off">
                                                {data.date_time ? new Date(data.date_time).toLocaleString() : ""}
                                            </div>
                                        </td>

                                        <td width={85} className="text-r text-h2">
                                            {data.date_time ? timeAgo(data.date_time) : ""}
                                        </td>

                                        <td width={30} className="cursor">
                                            <ShareButton url={`${data.contentid} ${" "} ${data.message}`} />
                                        </td>

                                    </tr>
                                </tbody>
                            </table>

                            <div
                                className=" text-h2 status_view_size"
                            // style={{
                            //     backgroundColor: data.statuscolor
                            // }}
                            >

                                <div

                                    className="bold text-h1 m-top line-height-25"
                                    dangerouslySetInnerHTML={{ __html: data.message }}
                                />
                                <div className="m-top">
                                    <table  >
                                        <tbody>
                                            <tr>
                                                <td  >
                                                    <div className="text-h2 text-l bold fcap" style={{ color: data.statuscolor }}>
                                                        {data.statusmoodEmoji} {data.statusmood}
                                                    </div>
                                                </td>
                                                <td className="text-h2 fcap text-r bold">
                                                    #{accountsdata[0]?.username}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="text-h2 ">
                                        https://status.aooz.in/{accountsdata[0]?.username}   </div>
                                </div>
                            </div>

                            <div className="p-0 ">
                                <table className="table-fixed">
                                    <tbody>
                                        <tr>

                                            <td>
                                                <div className="text-h3">
                                                    <b>{data.read + data.copy + data.like || 0}</b> Read
                                                </div>
                                            </td>

                                            <td>
                                                <div className="text-h3">
                                                    <b>{data.comment || 0}</b> Comt
                                                </div>
                                            </td>

                                            <td>
                                                {/* <IoColorPaletteOutline className="icon" /> */}
                                            </td>

                                            <td>
                                                <CopyUID
                                                    id={
                                                        data.message +
                                                        "\n" +
                                                        data.statusmoodEmoji + " #" + data.statusmood + " #aoozstatus #" + data.accountInfo?.username +
                                                        "\nhttps://status.aooz.in/" + data.accountInfo?.username
                                                    }
                                                    contentid={data.contentid}
                                                />
                                            </td>

                                            <td>

                                                <GoDownload
                                                    onClick={() => {
                                                        setDownloadingId(data);
                                                        setdownpopup(true)
                                                    }
                                                    }
                                                    className="icon cursor"
                                                />

                                            </td>

                                            <td>
                                                <GoHeart onClick={() => Update_status_message_qry(data.contentid, "like")} className="icon cursor" />
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="m-top ">
                            <textarea value={statuscomment} onChange={(e) => setStatuscomment(e.target.value)} placeholder="Enter comment" maxLength={200} className="p-1" row={4} />
                            <table>
                                <tr>
                                    <td className="text-h2 text-off">{statuscomment.length}/200</td>
                                    <td width={110}><div onClick={() => poststatuscomment()} className="button-ui p-11 cursor">Post Commint</div></td>
                                </tr>
                            </table>
                            <div className="ui-grid fill">

                                {commentsloading ? (
                                    <Loading />
                                ) : commentsdata.length > 0 ? (

                                    commentsdata.map((row) => (

                                        <div key={row.id} className="ui-items  b-1 m-top hover items-back p-11 rounded ">

                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td width={30} >
                                                            <img onClick={() => navigate("/" + row.accountInfo?.username)}
                                                                className="icon-photo-30 cursor"
                                                                src={row.accountInfo?.photoURL || "/default-user.png"}
                                                                alt="user"
                                                            />
                                                        </td>

                                                        <td onClick={() => navigate("/" + row.accountInfo?.username)}>
                                                            <div className="text-h2 bold">{row.accountInfo?.name}</div>
                                                            <div className="text-h4 text-off">
                                                                {row.date_time ? new Date(row.date_time).toLocaleString() : ""}
                                                            </div>

                                                        </td>


                                                        <td>
                                                            <div width={90} className="text-h3 text-r ">
                                                                {row.date_time ? timeAgo(row.date_time) : ""}
                                                            </div>

                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>

                                            <div
                                                className="rounded text-h1 "

                                            >

                                                <div

                                                    className=" m-top"
                                                    dangerouslySetInnerHTML={{ __html: row.message }}
                                                />

                                            </div>




                                        </div>

                                    ))

                                ) : (
                                    <p>No comments found</p>
                                )}

                            </div>
                        </div>
                    </div>

                    <div className="post_updates ">

                        <table>
                            <tr>
                                <td>
                                    <div className="text-h2 text-l fcap "> Recent status, update:
                                        {recentstatusdata[0]?.date_time ? timeAgo(recentstatusdata[0]?.date_time) : ""}</div>
                                </td>

                                <td width={130}>
                                    <table>
                                        <tr>

                                            <td width={100}>
                                                <table>
                                                    <tr>
                                                        <td><a href="https://whatsapp.com/channel/0029Vb8FTGGEQIaimh9UtB3o" target="_blank" rel="noopener noreferrer">
                                                            <img width="20" height="20" src={whatsapp} viewBox="0 0 24 24" fill="black">
                                                            </img>
                                                        </a></td>
                                                        <td><a href="https://instagram.com/aoozstatus" target="_blank">
                                                            <img width="20" height="20" src={instagram} viewBox="0 0 24 24" fill="black">
                                                            </img>
                                                        </a></td>
                                                        <td><a href="https://www.youtube.com/@aoozstatus" target="_blank">
                                                            <img width="20" height="20" src={youtube} viewBox="0 0 24 24" fill="black">
                                                            </img>
                                                        </a></td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>

                        <div className="ui-grid ">

                            {recentloading ? (
                                <Loading />
                            ) : recentstatusdata.length > 0 ? (

                                recentstatusdata.map((row) => (

                                    <div key={row.id} className="ui-items  hover items-back p-11 rounded ">

                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={30} onClick={() => navigate("/" + row.accountInfo?.username)}>
                                                        <img
                                                            className="icon-photo-30 cursor"
                                                            src={row.accountInfo?.photoURL || "/default-user.png"}
                                                            alt="user"
                                                        />
                                                    </td>

                                                    <td onClick={() => navigate("/" + row.accountInfo?.username)}>
                                                        <div className="text-h2 bold">{row.accountInfo?.name}</div>
                                                        <div className="text-h4 text-off">
                                                            {row.date_time ? new Date(row.date_time).toLocaleString() : ""}
                                                        </div>
                                                    </td>

                                                    <td width={85} className="text-r text-h2">
                                                        {row.date_time ? timeAgo(row.date_time) : ""}
                                                    </td>

                                                    <td width={30} className="cursor">
                                                        <ShareButton url={`${row.contentid} ${" "} ${row.message}`} />
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>

                                        <div
                                            className="rounded text-h1 recent_status_view_size"
                                        // style={{
                                        //     backgroundColor: row.statuscolor
                                        // }}
                                        >

                                            <div
                                                onClick={() => navigate("/" + row.contentid)}
                                                className=" bold m-top"
                                                dangerouslySetInnerHTML={{ __html: row.message }}
                                            />
                                            <div className="m-top">
                                                <table  >
                                                    <tbody>
                                                        <tr>
                                                            <td  >
                                                                <div className="text-h2 bold text-l fcap" style={{ color: row.statuscolor }}>
                                                                    {row.statusmoodEmoji} {row.statusmood}
                                                                </div>
                                                            </td>
                                                            <td className="text-h1 text-r bold">
                                                                #{row.accountInfo?.username}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="text-h1">
                                                    https://status.aooz.in/{row.accountInfo?.username}   </div>
                                            </div>
                                        </div>

                                        <div className="p-0 ">
                                            <table className="table-fixed">
                                                <tbody>
                                                    <tr>

                                                        <td>
                                                            <div className="text-h3">
                                                                <b>{row.read + row.copy + row.like || 0}</b> Read
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div onClick={() => navigate("/" + data.contentid)} className="cursor text-h3">
                                                                <b>{row.comment || 0}</b> Comt
                                                            </div>
                                                        </td>

                                                        <td>
                                                            {/* <IoColorPaletteOutline className="icon" /> */}
                                                        </td>
                                                        <td>
                                                            <CopyUID
                                                                id={
                                                                    row.message +
                                                                    "\n" +
                                                                    row.statusmoodEmoji + " #" + row.statusmood + " #aoozstatus #" + row.accountInfo?.username +
                                                                    "\nhttps://status.aooz.in/" + row.accountInfo?.username
                                                                }
                                                                contentid={row.contentid}
                                                            />
                                                        </td>

                                                        <td>

                                                            <GoDownload
                                                                onClick={() => {
                                                                    setDownloadingId(row);
                                                                    setdownpopup(true)
                                                                }
                                                                }
                                                                className="icon cursor"
                                                            />
                                                            {/* {
                                                                downloadingId === row.contentid
                                                                    ? <MdDownloadDone className="icon green" />
                                                                    : <GoDownload
                                                                        onClick={() =>
                                                                            downloadDivAsImage(
                                                                                row.contentid,
                                                                                "Aooz.in_" + row.statusmood + "_" + row.contentid
                                                                            )
                                                                        }
                                                                        className="icon cursor"
                                                                    />
                                                            } */}
                                                        </td>

                                                        <td>
                                                            <GoHeart onClick={() => Update_status_message_qry(row.contentid, "like")} className="icon cursor" />
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>

                                ))

                            ) : (
                                <p>No status found</p>
                            )}

                        </div>
                    </div>
                </div>
            </div>
            <Download_popup row={downloadingId}
                isOpen={downpopup}
                onClose={() => setdownpopup(false)}
            />
        </>
    );
}